// Runtime API base URL resolution
// On preview: uses REACT_APP_BACKEND_URL env var
// On deployed custom domains: uses empty string (relative URLs) to avoid CORS
const resolveBackendUrl = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1' && !host.includes('preview.emergentagent.com')) {
      return '';
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = resolveBackendUrl();
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
